import { Component, OnInit } from '@angular/core';
import { ɵangular_packages_platform_browser_platform_browser_a } from '@angular/platform-browser';
import { ErpService } from 'src/app/shared/services/erp.service';

@Component({
  selector: 'app-erp',
  templateUrl: './erp.component.html',
  styleUrls: ['./erp.component.scss']
})
export class ErpComponent implements OnInit {

  selectedModule;
  selectedType;
  viewTypes;
  tempModule;
  types = {
    11: "Parametros",
    12: "Documentos",
    13: "Procesos",
    14: "Consultas"
  }

  constructor(public erpS: ErpService) {
    this.selectedModule = '0';
    this.selectedType = '11'
    console.log('ERP Constructor')
  }

  ngOnInit(): void {
  }

}
